import { defineStore } from "pinia";
import { useGeneralStore } from "%/stores/general-store";
import useDynamicInputStore from "~/stores/dynamic-input-store";

export const NEWSLETTER_SUBSCRIPTION_INPUT_KEY = "email-subscription-input";

export const useNewsletterStore = defineStore("newsletter-store", {
  state: () => ({
    emailAddress: "",
    loadingSubscribeToEmail: false,
    subscribedNow: false,
    isSubscribed: false,
    subscriptionError: "",
  }),
  actions: {
    subscribeToEmail() {
      if (this.loadingSubscribeToEmail) {
        return;
      }

      const dynamicInputStore = useDynamicInputStore();
      const emailAddress = this.emailAddress || "";

      this.subscriptionError = "";
      this.subscribedNow = false;
      dynamicInputStore.clearDynamicInputError(NEWSLETTER_SUBSCRIPTION_INPUT_KEY);
      dynamicInputStore.clearDynamicInputSuccess(NEWSLETTER_SUBSCRIPTION_INPUT_KEY);

      if (!emailAddress) {
        this.subscriptionError = "Email is required";
        dynamicInputStore.setDynamicInputError(
          NEWSLETTER_SUBSCRIPTION_INPUT_KEY,
          "Email is required",
        );
        return;
      }

      this.loadingSubscribeToEmail = true;
      return this.apiPost(
        `${useGeneralStore().links.fanApiV1}/user/newsletter/subscribe`,
        {
          email: emailAddress,
        },
        () => {
          this.emailAddress = "";
          this.subscribedNow = true;
          this.isSubscribed = true;
          dynamicInputStore.setDynamicInputSuccess(
            NEWSLETTER_SUBSCRIPTION_INPUT_KEY,
            "Thanks for subscribing",
          );
        },
        error => {
          if (this.isExistingSubscriberError(error)) {
            this.isSubscribed = true;
            this.subscriptionError = "";
            this.emailAddress = "";
            dynamicInputStore.setDynamicInputSuccess(
              NEWSLETTER_SUBSCRIPTION_INPUT_KEY,
              "You're already subscribed",
            );
            return;
          }

          const errorMessage = this.getSubscriptionErrorMessage(error);
          this.subscriptionError = errorMessage;
          dynamicInputStore.setDynamicInputError(
            NEWSLETTER_SUBSCRIPTION_INPUT_KEY,
            errorMessage,
          );
        },
        () => {
          this.loadingSubscribeToEmail = false;
        },
      );
    },
    getSubscriptionErrorMessage(error) {
      return error?.response?.data?.message || "Unable to subscribe to the newsletter";
    },
    isExistingSubscriberError(error) {
      const errorMessage = error?.response?.data?.message;
      const alreadyAttachedError = errorMessage.toLowerCase().includes("the email address is already attached to a user for this app");
      const alreadyInvitedError = errorMessage.toLowerCase().includes("the user with this email address has already been invited");

      return alreadyAttachedError || alreadyInvitedError;
    },
    setIsSubscribed(value) {
      this.isSubscribed = value;
    },
  },
});
